import { gql } from '@apollo/client';

export const GET_CUSTOM_WIDGET_DATA = gql`
  query GetCustomWidgetData($dateRange: DateRange!) {
    getDays(dateRange: $dateRange) {
      id
      date
      customFieldValues {
        fieldId
        value
      }
    }
    getCustomFieldSections {
      id
      title
      fields {
        id
        name
        type
        options
        published
      }
    }
  }
`;

export const GET_DASHBOARD_WIDGETS = gql`
  query GetDashboardWidgets {
    getDashboardWidgets {
      id
      title
      fieldId
      sectionId
      chartType
      aggregation
      layout {
        x
        y
        w
        h
        minW
        minH
      }
      visible
      orderIndex
      isSystem
      systemKey
      createdAt
      updatedAt
    }
  }
`;
